'use client';

import * as Sentry from '@sentry/nextjs';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';
import { PageErrorMsg } from '@/app/components/shared/PageErrorMsg';
import { getFetchErrorMsg } from '@/app/utils/client';

export default function PageError({ error }: { error: Error }) {
  const t = useTranslations();

  useEffect(() => {
    // 向 Sentry 报告错误，但优先级低于 GlobalError
    Sentry.withScope((scope) => {
      scope.setLevel('error'); // 设置错误级别
      scope.setTag('errorType', 'pageError'); // 标记错误类型
      Sentry.captureException(error);
    });
  }, [error]);

  return (
    <div className="min-h-screen">
      <PageErrorMsg message={getFetchErrorMsg(error, t)} />
    </div>
  );
}
